<template>
  <footer>
    <b-container fluid>        
          <AppTimer class="timer-date showbox text-center" />
          <p>Aiga {{year}} | {{info}} | {{ cluster }}</p>  
    </b-container>
  </footer>
</template>

<script>
import $inoe from '@/config';
import { utils } from '../util';
import AppTimer from "./app-timer";
export default {
  name: "AppFooter",
  props: {
    hasTimer: {
      type: Boolean,
      default: false,
    },
    centerMd : {
      type : Number,
      default : 7
    }
  },
  components: {
    AppTimer,
  },
  computed: {
  },
  data() {
    return {
      info: $inoe.getApiVersion() ,
      year : utils.getCurrentTimeNow().format("YYYY"),
      cluster: $inoe.getCluster()
    }
  },
};
</script>

<style lang="scss" scoped>
footer {
  color: #c9cccd;
  background-color: #263238;
  width: 100%;
  max-height: 120px;
  p{
    margin: 0;
    padding: 0;
  }
}
.timer-date {
  font-size: calc(1rem + 1.2vw) !important;
  padding-top: 10px;
  font-weight: bold;
}
// Extra small devices (portrait phones, less than 576px)
@include media-breakpoint-up(sm) {
}
// Extra small devices (portrait phones, less than 576px)
@include media-breakpoint-up(md) {
}
// Extra small devices (portrait phones, less than 576px)
@include media-breakpoint-up(lg) {
}
</style>
